import { Link } from "react-router-dom";
import { useContext } from "react";
import ContentPage from "../components/ContentPage";
import { UserContext } from "../context/UserContext";

const About = () => {
  const { user } = useContext(UserContext);

  return (
    <ContentPage title="About">
      <h1 className="content-page__title">About PeerPoetry</h1>
      <p className="content-page__subtitle">
        A home for writers and readers to share, discover, and celebrate poetry.
      </p>
      <div className="peer-home-page-card p-5 sm:p-8 md:p-10 space-y-6 min-w-0 box-border">
        <p className="text-base sm:text-lg text-[#333333] leading-relaxed">
          <span className="font-semibold">PeerPoetry</span> makes it simple to
          create, connect, and be inspired—whether you&apos;re polishing a
          masterpiece or savoring a verse.
        </p>

        <div className="content-section">
          <h2>Create & Collaborate</h2>
          <ul>
            <li>Write, edit, and publish poems with a clean editor</li>
            <li>Pin a favorite poem to your profile</li>
            <li>Invite collaborators and co‑create</li>
          </ul>
        </div>

        <div className="content-section">
          <h2>Engage & Discover</h2>
          <ul>
            <li>Like, comment, and share poems you love</li>
            <li>Smart search with recent history</li>
            <li>Saved section to bookmark poems privately</li>
          </ul>
        </div>

        <div className="content-section">
          <h2>Real‑time Connection</h2>
          <ul>
            <li>Built‑in chat with typing indicators</li>
            <li>Delivered and seen receipts</li>
            <li>Notifications for likes and comments (incl. collaborators)</li>
          </ul>
        </div>

        <div className="content-section">
          <h2>Thoughtful Experience</h2>
          <ul>
            <li>Mobile‑friendly design with smooth interactions</li>
            <li>Secure authentication and account controls</li>
          </ul>
        </div>

        <div className="content-section">
          <h2>Our Mission</h2>
          <p className="mt-2 text-[#333333] leading-relaxed">
            We believe poetry is for everyone. Our goal is to lower the barrier
            to creation, foster collaboration, and help great writing find its
            audience—without noise or pressure.
          </p>
        </div>

        <div className="content-section">
          <h2>Roadmap</h2>
          <ul>
            <li>Collections for organizing saved poems</li>
            <li>Improved discovery (tags, trends, and curation)</li>
          </ul>
        </div>

        <div className="content-section text-center sm:text-left">
          <h2>Contact & Credits</h2>
          <p className="mt-2 text-[#333333] leading-relaxed">
            Made with care by the PeerPoetry team.
            <br />
            For feedback or support, use the{" "}
            <span className="font-semibold">Feedback</span> page or email{" "}
            <a
              href="mailto:support@peerpoetry.com"
              className="peer-home-link hover:underline"
            >
              support@peerpoetry.com
            </a>
            .
          </p>
        </div>

        <div className="pt-2 text-center">
          <Link
            to={user ? "/write" : "/login"}
            state={user ? undefined : { from: "/write" }}
            className="peer-home-btn-primary"
          >
            Start Writing
          </Link>
        </div>
      </div>
    </ContentPage>
  );
};

export default About;
